module.exports = __webpack_public_path__ + "static/media/savedCompBack.c24e1bff.svg";